import { render, staticRenderFns } from "./siteContent.vue?vue&type=template&id=76107ca6"
import script from "./siteContent.vue?vue&type=script&lang=js"
export * from "./siteContent.vue?vue&type=script&lang=js"
import style0 from "./siteContent.vue?vue&type=style&index=0&id=76107ca6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VContent})
